/* global YT, Vimeo */
import { loadYouTubeIframeAPI, initYouTubePlayer } from './youtube.js';

document.addEventListener('DOMContentLoaded', () => {
    const hero = document.querySelector('main .hero.has-dark-hv');
    const header = document.querySelector('header');

    const playButton = document.querySelector('.hero-video-controls .play-hv-video');
    const pauseButton = document.querySelector('.hero-video-controls .pause-hv-video');
    const videoType = document.querySelector('.hero-video-controls')?.dataset.type;

    let youtubePlayer;
    let vimeoPlayer;

    function initVimeoPlayer() {
        const vimeoContainer = document.querySelector('#hero-vimeo-player');

        const options = {
            autoplay: 1,
            muted: 1,
            loop: 1,
            controls: 0,
            setVolume: 0,
        };

        vimeoPlayer = new Vimeo.Player(vimeoContainer, options);

        vimeoPlayer.on('play', () => {
            toggleVimeoBtn('play');
        });

        vimeoPlayer.on('pause', () => {
            toggleVimeoBtn('pause');
        });

        vimeoPlayer.on('loaded', () => handleVimeoAutoplay('loaded'));
        vimeoPlayer.on('ready', () => handleVimeoAutoplay('ready'));
    }

    function handleVimeoAutoplay(eventName) {
        vimeoPlayer.setVolume(0).catch((err) => {
            console.error(`${eventName}: Muting failed`, err);
        });

        vimeoPlayer.play().catch((err) => {
            console.error(`${eventName}: Autoplay failed`, err);
        });
    }

    if (videoType === 'youtube') {
        loadYouTubeIframeAPI(() => {
            youtubePlayer = initYouTubePlayer(document.querySelector('#hero-youtube-player'), playButton, pauseButton, toggleYtBtn);
        });
    } else if (videoType === 'vimeo') {
        const vimeoScript = document.createElement('script');
        vimeoScript.src = 'https://player.vimeo.com/api/player.js';
        document.head.appendChild(vimeoScript);

        vimeoScript.onload = initVimeoPlayer;
    }

    function playVideo() {
        if (videoType === 'youtube' && youtubePlayer) {
            youtubePlayer.playVideo();
        } else if (videoType === 'vimeo' && vimeoPlayer) {
            vimeoPlayer.play();
        }
    }

    function pauseVideo() {
        if (videoType === 'youtube' && youtubePlayer) {
            youtubePlayer.pauseVideo();
        } else if (videoType === 'vimeo' && vimeoPlayer) {
            vimeoPlayer.pause();
        }
    }

    if (playButton && pauseButton) {
        playButton.addEventListener('click', (e) => {
            e.preventDefault();
            playVideo();
        });

        pauseButton.addEventListener('click', (e) => {
            e.preventDefault();
            pauseVideo();
        });
    }

    function toggleYtBtn(event) {
        if (playButton && pauseButton) {
            if (event.data === YT.PlayerState.PLAYING) {
                playButton.classList.remove('is-active');
                pauseButton.classList.add('is-active');
            } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                playButton.classList.add('is-active');
                pauseButton.classList.remove('is-active');
                if (event.data === YT.PlayerState.ENDED) {
                    youtubePlayer.playVideo();
                }
            }
        }
    }

    function toggleVimeoBtn(state) {
        if (playButton && pauseButton) {
            if (state === 'play') {
                playButton.classList.remove('is-active');
                pauseButton.classList.add('is-active');
            } else if (state === 'pause') {
                playButton.classList.add('is-active');
                pauseButton.classList.remove('is-active');
            }
        }
    }

    if (header) {
        if (hero) {
            header.classList.add('has-dark-hv');
            header.classList.remove('has-light-hv');
        } else {
            header.classList.add('has-light-hv');
            header.classList.remove('has-dark-hv');
        }
    }
});
